import { Dialog, Transition } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getIpDetials,
  postCreateLead,
  sendMobileOtp,
  verifyMobileOtp,
} from "../../api/api";
import ic_close from "../../assets/icons/ic_close.svg";
import curvOverlay from "../../assets/images/CurvOverlay_fitnessFreak.png";
import fitnessFreaks from "../../assets/images/fitnessFreaks.png";
import gobsquat from "../../assets/images/gobsquat.jpeg";
import upright_jump from "../../assets/images/upright_jump.jpg";
import { validPhone } from "../../utils/Utils";
import Button from "../basic/Button";
import CustomDialog from "../basic/Dialog";
import IconButton from "../basic/IconButton";
import OtpInput from "../basic/OtpInput";

// OTP VERIFICATION
function OtpVerifacation({
  mobile,
  otpVerification,
  onClickNext,
  sendOtp,
  hash,
  close,
  postCreateLeads,
}) {
  const [otp, setOtp] = useState("");

  async function verifyOtp() {
    if (otp.length != 4) {
      toast("Otp must be 4 digits");
      return;
    }
    let response;
    if (mobile) {
      response = await verifyMobileOtp(mobile, hash, otp);
      console.log(hash);
      if (response.status == 200) {
        onClickNext();
      } else {
        toast("Invalid OTP", { type: "error" });
      }
    }
  }

  useEffect(() => {
    if (!hash) sendOtp();
  }, []);

  return (
    <>
      <CustomDialog show={otpVerification} close={close}>
        <Dialog.Panel
          className="rounded-lg bg-[#0C101B] text-left shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg"
          // className="w-full flex b- flex-col items-center"
        >
          <div className="relative">
            <IconButton
              icon={ic_close}
              className="shadow-xl absolute -top-8 -right-12"
              onClick={() => {
                close();
              }}
            />
            <div className="text-white font-normal text-md font-poppins">
              Verify your mobile number
            </div>
            <OtpInput
              onOtpChanged={(otp) => {
                setOtp(otp);
              }}
            />
            <p
              className="text-primary-gray w-full text-end mt-3 cursor-pointer underline"
              onClick={() => {
                // sendOtp();
                
              }}
            >
              Resend
            </p>
          </div>
          <div className="flex justify-center">
            <Button
              onClick={async () => {
                // verifyOtp() ? postFitnessDetails() : "";
                verifyOtp();
                // postFitnessDetails();
                if (verifyOtp == true) {
                  await postCreateLeads();
                }
              }}
              type="primary"
              className={"mt-6"}
            >
              Verify
            </Button>
          </div>
        </Dialog.Panel>
      </CustomDialog>
    </>
  );
}

// Pop-up user-details
export function UserDetailsPopUp({
  fitnessAge,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  setMobile,
  setDob,
  mobile,
  dob,
  onClickNext,
  show,
  close,
}) {
  const [otpVerification, setOtpVerification] = useState(false);
  const [hash, setHash] = useState("");

  async function sendOtp() {
    let response;
    if (mobile) {
      response = await sendMobileOtp("+91" + mobile);
      console.log(mobile);
      if (response.status == 200) {
        toast("OTP Sent");
        setHash(response.hash);
      }
    }
  }

  // async function postCreateLeads() {
  //   let data = {
  //     first_name: firstName,
  //     last_name: lastName,
  //     mobile: mobile,
  //     dob: dob,
  //   };
  //   await postCreateLead(data);
  //   console.log(data);
  // }

  // CREATE LEAD
  async function postCreateLeads() {
    let leadData = {};
    const ipDetails = await getIpDetials();
    if (ipDetails) {
      leadData.user_city = ipDetails.ip;
      leadData.user_city = ipDetails.city;
      leadData.user_state = ipDetails.region;
      leadData.user_country = ipDetails.country;
      leadData.user_calling_code = ipDetails.country_calling_code;
    }
    leadData.first_name = document.getElementById("first_name").value;
    leadData.last_name = document.getElementById("last_name").value;
    leadData.mobile = document.getElementById("mobile").value;
    leadData.dob = document.getElementById("dob").value;
    // send the data to the server
    await postCreateLead(leadData);
    console.log("Create Lead :" + leadData);
  }

  // useEffect(() => {
  //   // this will be called whenever the component is re-rendered
  //   setFirstName("");
  //   setLastName("");
  //   setMobile("");
  //   setDob("");
  // }, []);

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   // your code to submit the form
  //   // you can also update any state variables here
  // };

  return (
    <>
      <CustomDialog show={show} close={close}>
        <OtpVerifacation
          mobile={validPhone(mobile) ? "+91" + mobile : null}
          otpVerification={otpVerification}
          onClickNext={() => {
            onClickNext();
          }}
          sendOtp={() => {
            sendOtp();
          }}
          hash={hash}
          postCreateLeads={() => postCreateLeads()}
          // postFitnessDetails={postFitnessDetails}
          close={() => {
            setOtpVerification(false);
          }}
        />
        <Dialog.Panel className="rounded-lg bg-[#0C101B] text-left shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
          <div className="relative">
            <IconButton
              icon={ic_close}
              className="shadow-xl absolute -top-8 -right-12"
              onClick={() => {
                close();
              }}
            />

            <div className="flex flex-col justify-center items-center">
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-4/12 text-white text-lg">
                  First Name*
                </p>
                <input
                  className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  id="first_name"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setFirstName("");
                      // toast("Please enter your name");
                    } else if (e.target.value.match(/^[A-Za-z]+$/)) {
                      setFirstName(
                        e.target.value
                          .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                          .replace(/[0-9]/g, "")
                      );
                    }
                  }}
                />
              </div>
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-4/12 text-white text-lg">
                  Last Name*
                </p>
                <input
                  className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  id="last_name"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setLastName("");
                      // toast("Please enter your last name");
                    } else if (e.target.value.match(/^[A-Za-z]+$/)) {
                      setLastName(
                        e.target.value
                          .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                          .replace(/[0-9]/g, "")
                      );
                    }
                  }}
                />
              </div>
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-4/12 text-white text-lg">
                  Mobile*
                </p>
                <input
                  className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  id="mobile"
                  placeholder="Mobile"
                  value={mobile}
                  onChange={(e) => {
                    // if (e.target.value.length === 0) {
                    //   toast("Please enter your mobile no");
                    // }
                    setMobile(e.target.value);
                  }}
                  maxLength="12"
                  type="number"
                  pattern="[0-9]+"
                />
              </div>
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-4/12 text-white text-lg">
                  Date of Birth*
                </p>
                <div className="md:w-80">
                  <DatePicker
                    selected={dob}
                    onChange={(date) => setDob(date)}
                    dateFormat="dd/MM/yyyy"
                    allowSameDay={false}
                    endDate={new Date()}
                    maxDate={new Date()}
                    placeholderText="Date of Birth"
                    popperPlacement="top-end"
                    closeOnScroll={false}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    id="dob"
                    className="flex flex-1 px-4 w-full h-100% py-3 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700"
                  />
                </div>
              </div>
              <div className="flex justify-end">
                <div
                  className="max-w-max mt-5 text-[#000000] cursor-pointer text-sm font-medium rounded-md bg-primary-neonGreen px-8 py-3"
                  onClick={async () => {
                    if (!firstName && fitnessAge) {
                      toast("First Name is required", { type: "error" });
                    } else if (!lastName && fitnessAge) {
                      toast("Last Name is required", { type: "error" });
                    } else if (!mobile && fitnessAge) {
                      toast("Enter your mobile no", { type: "error" });
                    } else if (!validPhone(mobile) && fitnessAge) {
                      toast("Invalid mobile", { type: "error" });
                    }
                    // else if (!validPhone(mobile) && fitnessAge && mobile) {
                    //   toast("Invalid mobile", { type: "error" });
                    // }
                    else if (!dob || dob == null || dob == " ") {
                      toast("Invalid Date of Birth", { type: "error" });
                    } else {
                      onClickNext();
                      // sendOtp();
                      // setOtpVerification(true);
                      // handleSubmit();
                    }
                  }}
                >
                  NEXT
                </div>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </CustomDialog>
      <Transition appear show={true} className="bg-[#1A1B22]">
        <Transition.Child
          enter="transform transition ease-in-out duration-300"
          leave="transform transition ease-in-out duration-300"
        ></Transition.Child>
      </Transition>
    </>
  );
}

export function TestYourFitness() {
  const [showStartDialog, setShowStartDialog] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState();
  const [dob, setDob] = useState("");
  const [dialogShow, setDialogShow] = useState(false);

  const navigate = useNavigate();

  // POST FITNESS AGE
  const loadUserData = async () => {
    if (firstName && lastName && mobile && dob) {


      let leadData = {};
      const ipDetails = await getIpDetials();
      if (ipDetails) {
        leadData.user_city = ipDetails.ip;
        leadData.user_city = ipDetails.city;
        leadData.user_state = ipDetails.region;
        leadData.user_country = ipDetails.country;
        leadData.user_calling_code = ipDetails.country_calling_code;
      }
      leadData.first_name = firstName;
      leadData.last_name = lastName;
      leadData.mobile = mobile;
      leadData.dob = dob
      .toLocaleString("en-us", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      await postCreateLead(leadData);

      window.location.href =
        // "https://http://app.getactyvphysio.com?firstName=" +
        "/Wellness?firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&mobile=" +
        mobile +
        "&dob=" +
        dob
          .toLocaleString("en-us", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
          .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3");
    }
  };
  // const createFitnessAge = async () => {
  //   if (fullName && mobile && dob) {
  //     window.location.href =
  //       "https://http://app.getactyvphysio.com/fitnessage?fullname=" +
  //       fullName +
  //       "&mobile=" +
  //       mobile +
  //       "&dob=" +
  //       dob;
  //   }
  // };

  // const navigateToWellness = async () => {
  //   const navigate = useNavigate();
  //   if (firstName && lastName && mobile && dob) {
  //     navigate("/wellnessfitnesslandingPage");
  //   }
  // };

  // async function postCreateLeads() {
  //   let data = {
  //     first_name: firstName,
  //     last_name: lastName,
  //     mobile: mobile,
  //     dob: dob,
  //   };
  //   await postCreateLead(data);
  //   console.log(data);
  // }

  // async function postCreateLeads() {
  //   let leadData = {}; // create an empty object to hold lead data

  //   // update leadData with user input
  //   leadData.first_name = document.getElementById("first_name").value;
  //   leadData.last_name = document.getElementById("last_name").value;
  //   leadData.mobile = document.getElementById("mobile").value;
  //   leadData.dob = document.getElementById("dob").value;

  //   // send the data to the server
  //   await postCreateLead(leadData);
  //   console.log(leadData);
  // }

  return (
    <>
      <UserDetailsPopUp
        fitnessAge={true}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        mobile={mobile}
        setMobile={setMobile}
        dob={dob}
        setDob={setDob}
        show={showStartDialog}
        close={() => {
          setShowStartDialog(false);
          setFirstName("");
          setLastName("");
          setMobile("");
          setDob("");
        }}
        onClickNext={(e) => {
          loadUserData();
          // e.preventDefault();
          // Clear input fields
          setFirstName("");
          setLastName("");
          setMobile("");
          setDob("");
        }}
      />
      <div className="w-full relative flex flex-col bg-primary-lightBlack rounded-xl p-8">
        <div className=" flex flex-col justify-center pb-4">
          <p className="font-poppins text-primary-neonGreen font-bold text-3xl md:text-4xl leading-snug">
            For <span className="text-white"> the new-age fitness freaks</span>
          </p>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-3 mt-5 gap-5">
          <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[280px] max-h-full">
            <div
              className="flex flex-1 transform rounded-lg h-full hover:shadow-2xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500 w-full"
              onClick={() => {
                setShowStartDialog(true);
              }}
            >
              <div
                style={{ backgroundImage: `url(${gobsquat})` }}
                className={` bg-center  bg-cover rounded-b-2xl rounded-t-lg w-full h-full flex flex-col`}
              >
                <div
                  className={`bg-black-400 bg-opacity-50 rounded-b-xl rounded-t-xl h-full`}
                >
                  <div
                    style={{ backgroundImage: `url(${curvOverlay})` }}
                    className="mt-32 w-full bg-cover rounded-b-2xl"
                  >
                    <div className="flex flex-col h-full">
                      <div className="px-2 pt-8 pb-2 flex flex-1 flex-col  justify-center items-center rounded-xl ">
                        <p
                          className={`font-poppins text-xl font-bold text-center text-primary-neonGreen`}
                        >
                          Check Your
                        </p>
                        <p className="font-bold font-poppins text-[#FFFFFF] text-3xl md:text-4xl">
                          AI Fitness Age
                        </p>
                        <button
                          className="flex justify-end items-center px-5 py-1 my-6 bg-primary-neonGreen text-black cursor-pointer rounded font-poppins text-base font-medium hover:shadow-2xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500"
                          onClick={() => {
                            setShowStartDialog(true);
                          }}
                        >
                          Start
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[280px] max-h-full">
            <div
              className="flex flex-1 transform rounded-lg h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500 w-full"
              onClick={() => {
                setShowStartDialog(true);
              }}
            >
              <div
                style={{ backgroundImage: `url(${upright_jump})` }}
                className={` bg-center  bg-cover rounded-b-2xl rounded-t-lg w-full h-full flex flex-col`}
              >
                <div
                  className={`bg-black-400 bg-opacity-50 rounded-b-2xl rounded-t-xl h-full`}
                >
                  <div
                    style={{ backgroundImage: `url(${curvOverlay})` }}
                    className="mt-32 w-full bg-cover rounded-b-2xl"
                  >
                    <div className="flex flex-col h-full">
                      <div className="px-2 pt-8 pb-2 flex flex-1 flex-col  justify-center items-center rounded-xl ">
                        <p
                          className={`font-poppins text-xl font-bold text-center text-primary-neonGreen`}
                        >
                          Know Your
                        </p>
                        <p className="font-bold font-poppins text-[#FFFFFF] text-3xl md:text-4xl">
                          Cardio Health
                        </p>
                        <button
                          className="flex justify-end items-center px-5 py-1 my-6 bg-primary-neonGreen text-black cursor-pointer rounded font-poppins text-base font-medium hover:shadow-2xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500"
                          onClick={() => {
                            setShowStartDialog(true);
                          }}
                        >
                          Start
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[280px] max-h-full">
            <div
              className="flex flex-1 transform rounded-lg h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500 w-full"
              onClick={() => {
                setShowStartDialog(true);
              }}
            >
              <div
                style={{ backgroundImage: `url(${fitnessFreaks})` }}
                // style={{ backgroundImage: `url(${gobsquat})` }}
                className={`bg-center bg-cover rounded-b-2xl rounded-t-lg w-full h-full flex flex-col`}
              >
                <div
                  className={`bg-black-400 bg-opacity-50 rounded-b-2xl rounded-t-xl h-full`}
                >
                  <div
                    style={{ backgroundImage: `url(${curvOverlay})` }}
                    className="mt-32 w-full bg-cover rounded-b-2xl"
                  >
                    <div className="flex flex-col h-full">
                      <div className="px-2 pt-8 pb-2 flex flex-1 flex-col  justify-center items-center rounded-xl ">
                        <p
                          className={`font-poppins text-xl font-bold text-center text-primary-neonGreen`}
                        >
                          Start With
                        </p>
                        <p className="font-bold font-poppins text-[#FFFFFF] text-3xl md:text-4xl">
                          Quick Stretches
                        </p>
                        <button
                          className="flex justify-end items-center px-5 py-1 my-6 bg-primary-neonGreen text-black cursor-pointer rounded font-poppins text-base font-medium hover:shadow-2xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500"
                          onClick={() => {
                            setShowStartDialog(true);
                          }}
                        >
                          Start
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
